/**
 * PrimaryPane — the primary group's tabs, all mounted, inside the document's
 * `main` landmark.
 *
 * This used to be `<Outlet />`, then a single tab resolved from `APP_ROUTES`.
 * It is now every primary tab at once; `TabSurfaces` owns that and the side
 * pane uses the same component, so the two panes cannot drift apart again.
 *
 * The `main` element lives here rather than on each tab. Every tab keeps its
 * DOM while hidden, so a landmark per tab would put several `main`s in the
 * document — and switching a tab's element type between `main` and `div` to
 * avoid that would remount it on every switch, which is the one thing the
 * design exists to prevent.
 */
import React from 'react';

import { TabSurfaces } from './TabSurfaces';

export const PrimaryPane: React.FC = () => (
  <main className="flex min-h-0 flex-1 flex-col">
    <TabSurfaces group="primary" />
  </main>
);
